export default "__VITE_ASSET__889251ba__"